import { Grid, Typography } from '@material-ui/core'
import React from 'react'
import CustomSwitch from './CustomSwitch'

export default function SwitchStatus({ value, name, form, setForm, label }) {
  return (
    <Grid item lg={4} style={{ marginTop: '22px' }}>
      <Typography style= {{ fontWeight: 600, fontSize: '14px', marginLeft: '5px' }}>{label || 'Status'}</Typography>
      <CustomSwitch checked={value} handleChange={() =>{
        if(name!== undefined){
          setForm({ ...form, [name]: !value })
        }else
        setForm({ ...form, active: !value })
      }} />
    </Grid>
  )
}



